export type FallbackExtension = 'png' | 'jpg';
export type ImageSizes = [number, number, number, number, number, number];

export type ImageType = {
  fallbackExtension: FallbackExtension;
  imagePath: string;
  offset: number;
  size: ImageSizes;
};

export type ImageMapType = {
  [key: string]: ImageType;
};

const SMALL_IMAGE_SIZES: ImageSizes = [225, 175, 145, 105, 76, 66];
const LARGE_IMAGE_SIZES: ImageSizes = [350, 300, 270, 180, 142, 120];

export const IMAGE_MAP: ImageMapType = {
  imageOne: {
    fallbackExtension: 'jpg',
    imagePath: '/span/quote-man-hosting-podcast',
    offset: 0,
    size: SMALL_IMAGE_SIZES,
  },
  imageTwo: {
    fallbackExtension: 'png',
    imagePath: '/span/rslash-cover-art',
    offset: 50,
    size: LARGE_IMAGE_SIZES,
  },
  imageThree: {
    fallbackExtension: 'jpg',
    imagePath: '/span/quote-man-with-microphone',
    offset: 100,
    size: SMALL_IMAGE_SIZES,
  },
};
